import CONFIG from 'config';

export function getDomain(): string {
  return localStorage.getItem(CONFIG.appPrefix + '_' + 'selectDomainDarzin');
}

export function setDomain(value: string) {
  localStorage.setItem(CONFIG.appPrefix + '_' + 'selectDomainDarzin', value);
}

export function setClientCode(value: string) {
  localStorage.setItem(CONFIG.appPrefix + '_' + 'clientCode', value);
}

export function getClientCode(): string {
  return localStorage.getItem(CONFIG.appPrefix + '_' + 'clientCode');
}

export function setProject(value: string | null) {
  if (!value) {
    localStorage.removeItem(CONFIG.appPrefix + '_' + 'project_id');
  } else {
    localStorage.setItem(CONFIG.appPrefix + '_' + 'project_id', value);
  }
}

export function getProject(): string | null {
  return localStorage.getItem(CONFIG.appPrefix + '_' + 'project_id');
}

export function setToken(value: string) {
  localStorage.setItem(CONFIG.appPrefix + '_' + 'token', value);
}

export function getToken(): string {
  return localStorage.getItem(CONFIG.appPrefix + '_' + 'token');
}

export function setTokenExpire(value: string) {
  localStorage.setItem(CONFIG.appPrefix + '_' + 'token_expire', value);
}

export function getTokenExpire(): string {
  return localStorage.getItem(CONFIG.appPrefix + '_' + 'token_expire');
}

export function setRefreshToken(value: string) {
  localStorage.setItem(CONFIG.appPrefix + '_' + 'refresh_token', value);
}

export function getRefreshToken(): string {
  return localStorage.getItem(CONFIG.appPrefix + '_' + 'refresh_token');
}

export function setAutosave(value: boolean) {
  localStorage.setItem(CONFIG.appPrefix + '_' + 'autosave', String(value));
}

export function getAutosave(): boolean {
  const value = localStorage.getItem(CONFIG.appPrefix + '_' + 'autosave');
  return value === 'true';
}
